module.exports = __webpack_public_path__ + "img/CurrencyPriceChange.4db4b9b2.svg";